module.exports = __webpack_public_path__ + "img/investment_money_pot.afc63c99.svg";